export const translations = {
  az: {
    common: {
      brand: "Əmlak.PRO",
      tagline: "Əmlak PRO professional agentliklər üçün əvəzolunmaz əmlak platformasıdır",
      search: "Axtar",
      searchByCode: "Elan kodu ilə axtar",
      viewDetails: "Ətraflı bax",
      showPhone: "Nömrəni göstər",
      allTypes: "Bütün növlər",
      allRegions: "Bütün rayonlar",
      allMetros: "Bütün metrolar",
      allRooms: "Bütün otaqlar",
      any: "Fərq etməz",
      min: "Min",
      max: "Max",
      priceFrom: "Qiymət (min)",
      priceTo: "Qiymət (max)",
      areaFrom: "Sahə (min)",
      areaTo: "Sahə (max)",
      apply: "Filtri tətbiq et",
      reset: "Sıfırla",
      loading: "Yüklənir...",
      noResults: "Heç bir nəticə tapılmadı",
      noResultsDesc: "Filtri dəyişməyi cəhd edin və ya bütün elanları görmək üçün sıfırlayın.",
      results: "nəticə",
      sort: "Sırala",
      sortNewest: "Ən yenilər",
      sortOldest: "Ən köhnələr",
      sortPriceAsc: "Ucuzdan bahaya",
      sortPriceDesc: "Bahadan ucuza",
      sortPopular: "Ən çox baxılan",
      grid: "Şəbəkə",
      list: "Siyahı",
      code: "Kod",
      area: "Sahə",
      floor: "Mərtəbə",
      rooms: "Otaq",
      metro: "Metro",
      region: "Rayon",
      seller: "Satıcı",
      description: "Təsvir",
      views: "baxış",
      addedToFavorites: "Seçilmişlərə əlavə edildi",
      removedFromFavorites: "Seçilmişlərdən çıxarıldı",
      copyPhone: "Kopyala",
      phoneCopied: "Nömrə kopyalandı",
      backToHome: "Ana səhifə",
      currency: "AZN",
      of: "/",
      previous: "Əvvəlki",
      next: "Növbəti",
      contactSeller: "Satıcı ilə əlaqə",
      details: "Məlumatlar",
      similar: "Oxşar elanlar",
    },
    nav: {
      home: "Ana səhifə",
      search: "Axtarış",
      favorites: "Seçdiklərim",
      popular: "Çox baxılanlar",
    },
    hero: {
      title: "Öz məkanınızı",
      titleAccent: "kəşf edin",
      subtitle: "Bakı və digər rayonlarda kirayə və satılıq elanların ən sadə axtarışı. Qeydiyyat yoxdur — sadəcə baxın.",
      searchPlaceholder: "Kod, ünvan və ya açar söz",
    },
    home: {
      featuredTitle: "Populyar elanlar",
      featuredSubtitle: "Bu həftə ən çox baxılan daşınmazlar",
      seeAll: "Hamısına bax",
      categoriesTitle: "Kateqoriyalar",
      whyTitle: "Niyə Əmlak.PRO?",
      why1Title: "Sürətli axtarış",
      why1Desc: "Bir kliklə min-lərlə elanı süzgəcdən keçirin.",
      why2Title: "Zəmanətli məlumat",
      why2Desc: "Yalnız yoxlanılmış və aktiv elanlar.",
      why3Title: "Ödənişsiz",
      why3Desc: "",
      //Baxış üçün heç bir qeydiyyat və ödəniş yoxdur.
      emptyDbTitle: "Elan bazamız hazırlanır",
      emptyDbDesc: "Sistemə tezliklə minlərlə elan əlavə olunacaq. Süzgəclər və filtrləmə funksiyaları isə hazırdır.",
    },
    empty: {
      favorites: "Seçdiklərim boşdur",
      favoritesDesc: "Ürəyinizcə olan elanları seçilmişlərə əlavə edin — bura qayıdanda hamısı sizi gözləyəcək.",
      popular: "Hələ heç bir baxılan elan yoxdur",
      popularDesc: "Elanlara baxıldıqca burada ən populyar olanlar görünəcək.",
      goBrowse: "Elanlara bax",
    },
  },
  ru: {
    common: {
      brand: "Эмлак.PRO",
      tagline: "Поиск недвижимости в Азербайджане",
      search: "Поиск",
      searchByCode: "Поиск по коду",
      viewDetails: "Подробнее",
      showPhone: "Показать номер",
      allTypes: "Все типы",
      allRegions: "Все районы",
      allMetros: "Все метро",
      allRooms: "Все комнаты",
      any: "Не важно",
      min: "Мин",
      max: "Макс",
      priceFrom: "Цена (мин)",
      priceTo: "Цена (макс)",
      areaFrom: "Площадь (мин)",
      areaTo: "Площадь (макс)",
      apply: "Применить",
      reset: "Сбросить",
      loading: "Загрузка...",
      noResults: "Ничего не найдено",
      noResultsDesc: "Попробуйте изменить фильтры или сбросьте их.",
      results: "результатов",
      sort: "Сортировка",
      sortNewest: "Сначала новые",
      sortOldest: "Сначала старые",
      sortPriceAsc: "По возрастанию цены",
      sortPriceDesc: "По убыванию цены",
      sortPopular: "Популярные",
      grid: "Сетка",
      list: "Список",
      code: "Код",
      area: "Площадь",
      floor: "Этаж",
      rooms: "Комнаты",
      metro: "Метро",
      region: "Район",
      seller: "Продавец",
      description: "Описание",
      views: "просмотров",
      addedToFavorites: "Добавлено в избранное",
      removedFromFavorites: "Удалено из избранного",
      copyPhone: "Копировать",
      phoneCopied: "Номер скопирован",
      backToHome: "На главную",
      currency: "AZN",
      of: "/",
      previous: "Назад",
      next: "Далее",
      contactSeller: "Связаться",
      details: "Информация",
      similar: "Похожие",
    },
    nav: {
      home: "Главная",
      search: "Поиск",
      favorites: "Избранное",
      popular: "Популярное",
    },
    hero: {
      title: "Найдите свою",
      titleAccent: "недвижимость",
      subtitle: "Простой поиск объявлений об аренде и продаже в Баку и других районах. Без регистрации — просто смотрите.",
      searchPlaceholder: "Код, адрес или ключевое слово",
    },
    home: {
      featuredTitle: "Популярные объявления",
      featuredSubtitle: "Самые просматриваемые за неделю",
      seeAll: "Все объявления",
      categoriesTitle: "Категории",
      whyTitle: "Почему Эмлак.PRO?",
      why1Title: "Быстрый поиск",
      why1Desc: "Тысячи объявлений в один клик.",
      why2Title: "Проверенные данные",
      why2Desc: "Только актуальные и активные предложения.",
      why3Title: "Бесплатно",
      why3Desc: "Никакой регистрации и оплаты.",
      emptyDbTitle: "База объявлений готовится",
      emptyDbDesc: "Тысячи объявлений скоро появятся. Фильтры и поиск уже работают.",
    },
    empty: {
      favorites: "Избранное пусто",
      favoritesDesc: "Добавляйте понравившиеся объявления в избранное.",
      popular: "Пока нет просмотренных объявлений",
      popularDesc: "Здесь появятся самые популярные.",
      goBrowse: "К объявлениям",
    },
  },
  en: {
    common: {
      brand: "Emlak.PRO",
      tagline: "Real estate search in Azerbaijan",
      search: "Search",
      searchByCode: "Search by code",
      viewDetails: "View details",
      showPhone: "Show phone",
      allTypes: "All types",
      allRegions: "All regions",
      allMetros: "All metros",
      allRooms: "All rooms",
      any: "Any",
      min: "Min",
      max: "Max",
      priceFrom: "Price (min)",
      priceTo: "Price (max)",
      areaFrom: "Area (min)",
      areaTo: "Area (max)",
      apply: "Apply filters",
      reset: "Reset",
      loading: "Loading...",
      noResults: "No results found",
      noResultsDesc: "Try adjusting filters or reset them to see all listings.",
      results: "results",
      sort: "Sort",
      sortNewest: "Newest first",
      sortOldest: "Oldest first",
      sortPriceAsc: "Price: low to high",
      sortPriceDesc: "Price: high to low",
      sortPopular: "Most viewed",
      grid: "Grid",
      list: "List",
      code: "Code",
      area: "Area",
      floor: "Floor",
      rooms: "Rooms",
      metro: "Metro",
      region: "Region",
      seller: "Seller",
      description: "Description",
      views: "views",
      addedToFavorites: "Added to favorites",
      removedFromFavorites: "Removed from favorites",
      copyPhone: "Copy",
      phoneCopied: "Phone copied",
      backToHome: "Home",
      currency: "AZN",
      of: "/",
      previous: "Previous",
      next: "Next",
      contactSeller: "Contact seller",
      details: "Details",
      similar: "Similar",
    },
    nav: {
      home: "Home",
      search: "Search",
      favorites: "Favorites",
      popular: "Popular",
    },
    hero: {
      title: "Discover your",
      titleAccent: "next place",
      subtitle: "The simplest way to browse rent and sale listings across Baku and other regions of Azerbaijan. No signup — just look.",
      searchPlaceholder: "Code, address or keyword",
    },
    home: {
      featuredTitle: "Popular listings",
      featuredSubtitle: "The most viewed properties this week",
      seeAll: "See all",
      categoriesTitle: "Categories",
      whyTitle: "Why Emlak.PRO?",
      why1Title: "Fast search",
      why1Desc: "Filter through thousands of listings in a click.",
      why2Title: "Trusted data",
      why2Desc: "Only verified and active listings.",
      why3Title: "Free forever",
      why3Desc: "No registration, no payments to browse.",
      emptyDbTitle: "Our database is warming up",
      emptyDbDesc: "Thousands of listings will be added soon. Filters are ready.",
    },
    empty: {
      favorites: "No favorites yet",
      favoritesDesc: "Save the listings you love. They'll be waiting here.",
      popular: "No popular listings yet",
      popularDesc: "The most viewed properties will appear here.",
      goBrowse: "Browse listings",
    },
  },
};

export const LANGS = ["az", "ru", "en"];
